<script>
import gsap from "gsap";
import ScrollTo from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTo);

export default {
  data() {
    return {
      isSmall: false,
      showMenu: false,
      scrollSpeed: 8000,
      scrollEasing: "linear",
      mediaQuery: null,
      observer: null,
      rootLang: document.documentElement.lang,
      linkProps: {
        url: "link='http://www.vectorworks.net/trial'",
        tgt: "_self",
      },
      langsWithModal: [
        "es-AR",
        "en-NZ",
        "da-DK",
        "nb-NO",
        "fi-FI",
        "en-FI",
        "nl-NL",
        "nl-BE",
        "fr-FR",
        "fr-BE",
        "pl-PL",
        "it-IT",
        "pt-BR",
        "ja-JP",
        "ja-JP",
      ],
      langsWithTrial: ["de-DE", "de-CH", "de-AT"],
    };
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
  created() { },
  mounted() {
    this.observer = new IntersectionObserver(this.watchSections, {
      threshold: 0.1,
    });
    this.mediaQuery = window.matchMedia("(min-width: 1200px)");
    this.mediaQuery.addEventListener("change", this.handleMediaQueryChange);
    this.handleMediaQueryChange(``);
    this.setObserver();
    this.setTrialLink();
  },
  methods: {
    setObserver() {
      const obsTargets = document.querySelectorAll(".section-wrapper");
      obsTargets.forEach((e) => {
        this.observer.observe(e);
      });
    },
    watchSections(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          console.log(entry.target);
        }
      });
    },
    handleMediaQueryChange() {
      if (this.mediaQuery.matches) {
        this.isSmall = false;
        this.showMenu = true;
      } else {
        this.isSmall = true;
        this.showMenu = false;
      }
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    closeMenu() {
      if (this.showMenu && this.isSmall) {
        this.showMenu = false;
      }
    },
    scrollToSection(anchor) {
      if (this.isSmall === true && anchor != "hero") {
        this.toggleMenu();
      }
      const targetSection = document.querySelector(`#${anchor}`);
      const currentScroll = document.documentElement.scrollTop;
      const totalDistance = Math.abs(
        targetSection.getBoundingClientRect().top - currentScroll
      );
      const scrollDuration = totalDistance / this.scrollSpeed;
      gsap.to(window, {
        duration: scrollDuration,
        scrollTo: `#${anchor}`,
        ease: this.scrollEasing,
      });
    },
    setTrialLink() {
      if (this.langsWithTrial.includes(this.rootLang)) {
        this.linkProps.url =
          "https://www.computerworks.eu/vectorworks/testversion/";
        this.linkProps.tgt = "_blank";
      }
    },
    showTrialModal() {
      return this.langsWithTrial.includes(this.rootLang);
    },
    checkTarget() {
      const regEx = new RegExp("vectorworks.net");
      const str = this.content.buyNowLink;
      if (regEx.test(str)) {
        return "_self";
      } else {
        return "_blank";
      }
    },
  },
  computed: {
    showBuyModal() {
      return this.langsWithModal.includes(this.rootLang);
    },
  },
};
</script>
<template>
  <div class="utilityNavWrapper">
    <div class="fake" v-show="showMenu" @click="toggleMenu"></div>
    <div class="utilityNav" @click.self="closeMenu">
      <p @click.self="scrollToSection('hero')" class="navTitle">
        {{ content.title }}
      </p>
      <transition name="slideT">
        <nav v-show="showMenu">
          <a v-for="link in content.links" :href="`#${link.anchor}`" :key="link.anchor"
            @click.prevent.self="scrollToSection(link.anchor)" class="navItem">
            {{ link.label }}
          </a>

          <div class="btnWrapper" @click="closeMenu">
            <vw-button v-if="showBuyModal" :label="content.buyNowLabel" :href="content.buyNowLink"
              data-modal-control="true" data-modal-controller-method="buy-request-quote-form"
              data-modal-size="normal" />

            <vw-button v-else-if="rootLang === 'fr-CH'" :label="content.buyNowLabel" href="http://www.x-yz.ch"
              target="_blank" />
            <vw-button v-else :label="content.buyNowLabel" :href="content.buyNowLink" :target="checkTarget()" />

            <vw-button v-if="!showTrialModal()" :label="content.freeTrialLabel" secondary data-gtm-id="7"
              :href="linkProps.url" :target="linkProps.tgt" data-modal-control="true"
              data-modal-controller-method="trial-form" data-modal-size="normal" />

            <vw-button v-else secondary :label="content.freeTrialLabel" :href="linkProps.url" :target="linkProps.tgt" />
          </div>
        </nav>
      </transition>

      <AppIconBase @click.native="toggleMenu" v-if="isSmall" :class="{ iconOpen: showMenu }" name="CircCloseIcon"
        class="icon" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "../styles/01-settings/breakpoints";
@import "../styles/01-settings/mq";

.fake {
  width: 100%;
  background: red;
  opacity: 0;
  position: absolute;
  height: 100vh;
  top: 0;
  z-index: -1;
}

.utilityNavWrapper {
  --btn-padding: 25px;
  --btn-height: 40px;
  --size: 26px;
  --nav-height: 52px;
  height: var(--nav-height);
  background-color: var(--secondary);
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 1000;
  align-items: center;
  display: flex;
}

.utilityNav {
  align-items: center;
  display: flex;
  margin: 0 auto;
}

.navTitle {
  color: #000000;
  display: block;
  font-size: 18px;
  font-family: Din !important;
  font-stretch: condensed;
  font-weight: 500;
  letter-spacing: 0.9px;
  line-height: 51.75px;
  margin: 0 auto;
  text-align: center;
}

nav {
  display: flex;
  flex-direction: column;
  position: absolute;
  background-color: hsla(360, 100%, 100%, 0.95);
  top: 100%;
  left: 0;
  width: 100vw;
  padding: 0;
  padding-left: 20px;
  font-family: Din;
}

.navItem {
  font-size: 13px;
  text-align: left;
  font-weight: 300;
  list-style: none;
  letter-spacing: 0.65px;
  padding: 25px 0;
  cursor: pointer;
  position: relative;
  text-decoration: none;
  border-bottom: 1px solid #c5c5c4;

  &:before {
    background-color: currentColor;
    color: var(--primary);
    content: "";
    height: 1px;
    left: 0;
    opacity: 1;
    position: absolute;
    top: 100%;
    transform-origin: center center;
    transform: scaleX(0);
    transition: transform 0.18s ease-out;
    width: 100%;
    z-index: -1;
  }

  &:hover {
    &:before {
      transform: scaleX(1);
    }
  }
}

.btnWrapper {
  display: flex;
  padding: 25px 0;
}

.vw-button {
  margin: 0;

  &:first-of-type {
    margin-right: 20px;
  }
}

.icon {
  position: absolute;
  right: 20px;
  transform-origin: center center;
  transition: transform 0.17s ease-out;
  cursor: pointer;
}

.iconOpen {
  transform: rotate(45deg);
}

@include mq($until: xs) {
  .btnWrapper {
    // flex-direction: column;
    // gap: 30px;
  }

  .vw-button:last-child {
    // margin-top: 30px;
    margin-left: 0px;
  }
}

@include mq($from: md) {
  .utilityNavWrapper {
    --nav-height: 75px;
  }

  .navTitle {
    letter-spacing: 1.8px;
  }
}

@include mq($from: lg) {
  .fake {
    display: none;
  }

  nav {
    display: flex;
    background-color: transparent;
    flex-direction: row;
    gap: 18px;
    padding: 0;
    position: static;
    align-items: center;
    width: max-content;
    margin: 0 auto;
  }

  .navItem {
    padding: 0;
    border: 0;
  }

  .navTitle {
    font-size: 36px;
  }
}

@include mq($from: lg, $until: xl) {
  .navTitle {
    display: none;
  }
}

@include mq($from: xl) {
  .navTitle {
    display: block;
  }

  .utilityNav {
    margin: 0 auto;
    width: 100%;
    max-width: 1400px;
  }

  .btnWrapper {
    margin-left: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/vuejs/frontend/2023-launch/components/UtilityNav.vue